// src/menu-items/Admin.js
import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
// import Inventory2Icon from "@mui/icons-material/Inventory2";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import SellIcon from "@mui/icons-material/Sell";
import OutboxIcon from "@mui/icons-material/Outbox";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import StoreIcon from "@mui/icons-material/Store";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import { useAuth } from "../hooks/useAuth";
import { hasPermission } from "../utils/permissionUtils";

const CarRoutes = () => {
  const { permissions } = useAuth();

  const generateAdminRoutes = () => {
    const carRoutes = [
      /* Dashboard Menu */

      {
        title: "Dashboard",
        items: [
          {
            path: "/car/dashboard_car",
            name: "Dashboard",
            icon: <DashboardIcon />,
          },
        ],
      },

      /* หมวดหมู่สินค้า รถมือสอง */

      hasPermission(permissions, ["List_Products", "Edit_Products", "car"]) && {
        title: "สินค้า",
        items: [
          {
            path: "/car/all_car",
            name: "รถทั้งหมด",
            icon: <DirectionsCarFilledIcon />,
          },
          {
            path: "/car/buy_car",
            name: "รถที่ซื้อแล้ว",
            icon: <RequestPageIcon />,
          },
          {
            path: "/car/ready_car",
            name: "รถพร้อมขาย",
            icon: <ShoppingCartIcon />,
          },
          {
            path: "/car/borrow_car",
            name: "รถถูกยืม/คืน",
            icon: <SwapHorizontalCircleIcon />,
          },
          {
            path: "/car/overdue_borrow_car",
            name: "รถเกินกำหนดยืม",
            icon: <AccessTimeFilledIcon />,
          },
          {
            path: "/car/sold_car",
            name: "รถขายแล้ว",
            icon: <RemoveShoppingCartIcon />,
          },
          {
            path: "/car/overdue_pawn_car",
            name: "รถหลุดจำนำ",
            icon: <HourglassBottomIcon />,
          },
        ],
      },

      /* หมวดหมู่รายการ รถมือสอง */

      hasPermission(permissions, ["List1", "Edit_List1", "car"]) && {
        title: "รายการ",
        items: [
          {
            path: "/car/sell_on_consignmen_car",
            name: "รายการขายฝาก",
            icon: <SellIcon />,
          },
          {
            path: "/car/redemption_car",
            name: "รายการไถ่ถอน",
            icon: <OutboxIcon />,
          },
          {
            path: "/car/setting_price_car",
            name: "ตั้งค่าราคาขาย",
            icon: <PaidIcon />,
          },
          {
            path: "/car/list_by_customer_car",
            name: "รายการแยกตามชื่อลูกค้า",
            icon: <ContactPageIcon />,
          },
          { path: "/car/bin_car", name: "ถังขยะ", icon: <DeleteIcon /> },
          {
            path: "/car/customer_list_car",
            name: "รายชื่อลูกค้า",
            icon: <PeopleAltIcon />,
          },
        ],
      },

      // /* หมวดหมู่รายงาน รถมือสอง */

      hasPermission(permissions, ["List_Report", "Edit_Report", "car"]) && {
        title: "รายงาน",
        items: [
          {
            path: "/car/inventory_car",
            name: "ทรัพย์คงคลัง",
            icon: <StoreIcon />,
          },
          {
            path: "/car/income_expenses_car",
            name: "รายรับ",
            icon: <PriceChangeIcon />,
          },
          {
            path: "/car/interest_car",
            name: "ดอกเบี้ย",
            icon: <TrendingUpIcon />,
          },
        ],
      },

      // /* หมวดหมู่นำเข้าข้อมูลย้อนหลัง รถมือสอง */

      hasPermission(permissions, ["List_Import", "Edit_Import", "car"]) && {
        title: "นำเข้าข้อมูลย้อนหลัง",
        items: [
          {
            path: "/car/import_data_car",
            name: "รายการนำเข้า",
            icon: <SummarizeIcon />,
          },
          {
            path: "/car/import_information_car",
            name: "นำเข้าข้อมูลขายฝาก",
            icon: <SellIcon />,
          },
          {
            path: "/car/import_information_buy_car",
            name: "นำเข้าข้อมูลซื้อ",
            icon: <RequestPageIcon />,
          },
          {
            path: "/car/import_list_car",
            name: "นำเข้าข้อมูลรายการ",
            icon: <OutboxIcon />,
          },
        ],
      },
    ].filter(Boolean);

    return carRoutes;
  };

  return generateAdminRoutes(); // Call the function to get the routes
};

export default CarRoutes;
